import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Typography } from '@mui/material';

//Actions
import {
    deleteUnsubscribedContactCloseModal,
    deleteUnsubscribedContactRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteUnsubscribedContact = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();

    const { messages } = useIntl();

    const { deleteUnsubscribedContact, loading, openModal, unsubscribedContacts } = useSelector(state => state.deleteUnsubscribedContactRedux);

    const closeModal = () => {
        dispatch(deleteUnsubscribedContactCloseModal());
        dispatch(clearRedux("UNSUBSCRIBED_CONTACT_DELETE"));
    }

    const deleteUsers = () => {
        dispatch(deleteUnsubscribedContactRequest(unsubscribedContacts))
    }

    useEffect(() => {
        if (deleteUnsubscribedContact) {
            NotificationManager.success(
                messages['unsubscribed_contacts_delete_have_been_removed'],
                messages['unsubscribed_contacts_delete_title'],
                3000
            );
            tableRef?.current?.getData();
            dispatch(clearRedux("UNSUBSCRIBED_CONTACT_DELETE"));
        }
    }, [deleteUnsubscribedContact])

    return (
        <Modal
            open={openModal}
            title={messages['unsubscribed_contacts_delete_title']}
            size="small"
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages['unsubscribed_contacts_delete_do_you_want_to']}
                    </Typography>
                    {
                        (unsubscribedContacts && unsubscribedContacts?.length) &&
                        <ul style={{ marginTop: 5 }}>
                            {
                                unsubscribedContacts.map((item, key) => {
                                    return (
                                        <li key={key}>
                                            {`${item?.to || ''}`}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => closeModal()}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => deleteUsers()}
                    >
                        {messages['delete']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default DeleteUnsubscribedContact;